module.exports = __webpack_public_path__ + "static/investors-info7-e0fcdbb68a0426d11735af0585071cf1.jpg";